module.exports = __webpack_public_path__ + "static/img/45.243cad0.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/Office365Deployment/45.png
// module id = 2x5r
// module chunks = 1